import { v4 as uuid } from 'uuid';
import { getLogger } from './logger';
const logger = getLogger('common');
export function getUuid() {
    try {
        return uuid();
    }
    catch (error) {
        logger.debug('creating uuid failed, trying with custom rng', error);
        return uuid({
            rng: () => {
                const randomNumbers = new Array(16);
                let r;
                for (let i = 0; i < 16; i++) {
                    if ((i & 0x03) === 0)
                        r = Math.random() * 0x100000000;
                    randomNumbers[i] = (r >>> ((i & 0x03) << 3)) & 0xff;
                }
                return randomNumbers;
            },
        });
    }
}
//# sourceMappingURL=uuid.js.map